import React from "react";

export function PageTemplate({ children, className }: any) {
  return <div className={`dashboard-pages ${className}`}>{children}</div>;
}
